module.exports = __webpack_public_path__ + "static/media/android_development.cc6d2e5b.svg";